import { Cookie, Header } from "../CustomModelsCreation/CustomParameters/types";
import { FormModelInfo } from "../types";

export const getInferenceClientRequestData = (
  modelInfo: FormModelInfo,
  headers: Header[],
  cookies: Cookie[],
  timeout: number,
  workspaceId: string,
) => {
  return {
    workspace_id: Number(workspaceId),
    api_key: modelInfo.apiKey,
    name: modelInfo.displayName,
    model: modelInfo.modelName,
    timeout,
    headers: headers.reduce(
      (acc, header) => {
        acc[header.key] = header.value;
        return acc;
      },
      {} as Record<string, string>,
    ),
    cookies: cookies.reduce(
      (acc, cookie) => {
        acc[cookie.key] = cookie.value;
        return acc;
      },
      {} as Record<string, string>,
    ),
  };
};
